import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "bgjc_token";
export const PREVIEW_TOKEN_KEY = "bgjc_view_as_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function getToken() {
  return sessionStorage.getItem(PREVIEW_TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
}

export function isPreviewSession() {
  return !!sessionStorage.getItem(PREVIEW_TOKEN_KEY);
}

export function startPreviewSession(token) {
  sessionStorage.setItem(PREVIEW_TOKEN_KEY, token);
}

export function endPreviewSession() {
  sessionStorage.removeItem(PREVIEW_TOKEN_KEY);
}
